<template>
    <div>
        <div id="disclaimed"></div> 
        <vue-simple-markdown :source="content"/>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: 'Disclaimer',
    data() {
        return {
            content: '',
        }
    },
    created() {
        this.getDisclaimer()
    },
    methods :{
        getDisclaimer() {
            axios.get("/api/article/5").then(response => {
                this.content = response.data[0].description
            })
        },
    }
}
</script>

<style scoped>
#disclaimed {
    margin-top: -70px;
    position: absolute;
}
@media screen and (max-width: 768px) {
    #disclaimed {
        margin-top: -50px;
    }
}
</style>